<template>
  <div class="main">
    <div id="container" class="mymap"></div>
    <div class="realLeft">
      <div class="oldBox">
        <div class="leftTitle">站点等级占比</div>
        <div id="currentSituation"></div>
      </div>
      <div class="oldBox">
        <div class="leftTitle">建筑面积</div>
        <div id="currentBulidingArea"></div>
      </div>
      <div class="oldBox">
        <div class="leftTitle">工作人员数</div>
        <div id="bedNums"></div>
      </div>
    </div>
    <div class="realRight">
      <div class="oldBox" style="height: 12vh">
        <div class="leftTitle">房屋性质</div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 16vh;
          "
        >
          <div class="housexz">
            <el-progress
              :text-inside="true"
              :stroke-width="24"
              :percentage="100"
              status="success"
            ></el-progress>
            <span style="color: #fff">服务用房</span>
          </div>
          <div class="housexz">
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="0"
              status="exception"
            ></el-progress>
            <span style="color: #fff">其他</span>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div class="oldBox" style="flex: 1; height: 30vh">
          <div class="leftTitle">活动总数</div>
          <div style="position: relative; text-align: center; margin-top: 32px">
            <img style="width: 210px" src="./assets/big/hz.png" alt="" />
            <div
              style="
                text-align: center;
                position: absolute;
                top: 38%;
                left: 44%;
              "
            >
              <p style="font-weight: blod; font-size: 18px; color: #fff">
                {{ alltotal }}
              </p>
              <p class="smallt" style="font-size: 12px">活动总数</p>
            </div>
          </div>
          <div class="newSty">
            <span style="25px;">志愿</span
            ><el-progress
              color="#D800FF"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label1"
            ></el-progress
            ><span>{{ label1 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">养生</span
            ><el-progress
              color="#7FD42D"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label2"
            ></el-progress
            ><span>{{ label2 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">健身</span
            ><el-progress
              color="#F21B62"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label3"
            ></el-progress
            ><span>{{ label3 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">法律</span
            ><el-progress
              color="#0F5BF5"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label4"
            ></el-progress
            ><span>{{ label4 }}%</span>
          </div>
          <div class="newSty">
            <span style="25px;">其他</span
            ><el-progress
              color="#50b7c1"
              :show-text="false"
              :format="format"
              :stroke-width="10"
              :percentage="label5"
            ></el-progress
            ><span>{{ label5 }}%</span>
          </div>
        </div>
        <div class="oldBox" style="flex: 1; height: 30vh; margin-left: 20px">
          <div class="leftTitle">参与</div>
          <div id="olderJoin"></div>
        </div>
      </div>
      <div class="oldBox" style="height: 35vh; padding: 25px 0 0 10px">
        <div class="leftTitle">活动集锦</div>

        <div style="display: flex">
          <div class="activeList">
            <div class="ac-title" style="display: flex">
              <div style="width: 50px">序号</div>
              <!-- <div style="flex: 1">活动类型</div> -->
              <div style="flex: 1">活动名称</div>
            </div>
            <div class="houseContent" style="height: 300px; overflow: scroll">
              <!-- <vue-seamless-scroll
                :style="{
                  height: this.scrollHeight + 'px',
                }"
                :data="activesList"
                :class-option="defaultOption"
                class="warp-content"
              > -->
              <div
                class="ac-item"
                style="display: flex"
                v-for="(item, index) in activesList"
                :key="index"
                @click="showInfo(item.id)"
              >
                <div style="width: 50px">{{ index + 1 }}</div>
                <!-- <div
                    style="
                      flex: 1;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <span v-if="item.type == 1">图文</span>
                    <span v-if="item.type == 2">视频</span>
                  </div> -->
                <div style="flex: 1">{{ item.name }}</div>
              </div>
              <!-- </vue-seamless-scroll> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 站点信息弹窗 -->
    <div class="perInfoBox2" v-if="showJiJinInfo2">
      <div class="info-txt2">
        <div class="info-item2">
          <p class="intitle2" style="margin-bottom: 15px; background: #162a5b">
            站点信息详情
          </p>
          <p>基本信息</p>
          <div style="width: 100%; height: 200px; background: #162a5b">
            <div
              style="
                width: 160px;
                height: 160px;
                margin: 20px 20px 0 0;
                float: right;
              "
            >
              <img class="defaultImg" src="./assets/big/default.jpg" alt="" />
            </div>
            <div>
              <div style="padding: 10px; width: 500px; color: #85c2ff">
                <span
                  ><label for="">站点名称：</label>{{ info.stationName }}</span
                >
                <p style="margin-top: 10px">
                  <label for="">联系人：</label>{{ info.concatNam }}
                </p>
                <p style="margin-top: 10px">
                  <label for="">联系方式：</label>{{ info.phone }}
                </p>

                <p style="margin-top: 10px">
                  <label for="">地址：</label>{{ info.stationAddress }}
                </p>
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-around;
                height: 233px;
                margin-top: 33px;
              "
            >
              <div style="width: 100%">
                <p style="text-align: center">活动锦集</p>
                <div style="height: 199px; background: #162a5b"></div>
              </div>
            </div>
          </div>
        </div>
        <span class="close-info2" @click="showJiJinInfo2 = false">×</span>
      </div>
    </div>
    <!-- 服务人员信息 -->
    <div class="perInfoBox2" v-if="showJiJinInfo1">
      <div class="info-txt2">
        <div class="info-item2">
          <p class="intitle2" style="margin-bottom: 15px; background: #162a5b">
            服务人员详情
          </p>
          <p>基本信息</p>
          <div style="width: 100%; height: 300px; background: #162a5b">
            <div
              style="
                width: 160px;
                height: 300px;
                margin: 20px 20px 0 0;
                float: right;
              "
            >
              <img
                class="defaultImg"
                v-if="pInfo.personSex == 1"
                src="./assets/big/boy.png"
                alt=""
              />
              <img
                class="defaultImg"
                v-else
                src="./assets/big/girl.png"
                alt=""
              />
            </div>
            <!-- <div> -->
            <div style="padding: 10px; width: 500px; color: #85c2ff">
              <span><label for="">姓名：</label>{{ pInfo.personName }}</span>
              <p style="margin-top: 10px">
                <label for="">联系方式：</label>{{ pInfo.personPhone }}
              </p>
              <p style="margin-top: 10px">
                <label for="">性别：</label
                >{{ pInfo.personSex == 1 ? "男" : "女" }}
              </p>
              <p style="margin-top: 10px">
                <label for="">年龄：</label>{{ pInfo.personAge }}
              </p>
              <p style="margin-top: 10px">
                <label for="">地址：</label>{{ pInfo.address }}
              </p>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <span class="close-info2" @click="showJiJinInfo1 = false">×</span>
      </div>
    </div>
    <div class="perInfoBox2" v-if="showJiJinInfo3">
      <div
        class="info-txt3"
        style="margin-top: 12%; background: rgba(10, 88, 160, 0.8)"
      >
        <div style="width: 100%">
          <p class="intitle" style="background: #4a79fd">
            <span style="margin-left: 10px">活动详情</span>
          </p>
          <span class="close-info" @click="close">×</span>
        </div>
        <div style="overflow-y: scroll; height: 65vh">
          <p style="text-align: center; font-size: 20px">
            {{ huodongForm.name }}
          </p>
          <img
            :src="huodongForm.photo1"
            style="width: 50%; margin-left: 25%; margin-top: 10px"
          />
          <img
            :src="huodongForm.photo2"
            style="width: 50%; margin-left: 25%; margin-top: 10px"
          />
          <p style="margin: 20px">{{ huodongForm.content }}</p>
          <p style="margin: 20px">{{ huodongForm.content2 }}</p>
          <p style="margin: 20px">{{ huodongForm.content3 }}</p>
          <p style="margin: 20px">{{ huodongForm.content4 }}</p>
          <p style="margin: 20px">{{ huodongForm.content5 }}</p>
          <p style="margin: 20px">{{ huodongForm.content6 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
  name: "visualized",
  data() {
    return {
      huodongForm: {},
      showJiJinInfo3: false,
      alltotal: 0, //总数
      label1: "",
      label2: "",
      label3: "",
      label4: "",
      label5: "",
      scrollHeight: 786,
      activesList: [
        {
          id: "1",
          name: "家朋乡党坑村：“小灯泡”照亮老人心窝窝",
          photo1: require("./assets/big/wei1.png"),
          photo2: require("./assets/big/wei2.png"),
          content1:
            " “真是太谢谢许老师了”，家住党坑村方家的程一枝老人感慨地说道。",
          content2:
            " 程一枝是党坑村的建档立卡贫困户，年过八旬，平日独自一人住一间房，家中光线本就灰暗，白天不开灯几乎看不见。扬之小学的许晓雄老师是刚刚接替帮扶她的联系人，第一次来到程一枝的家中走访，许老师就发现家里的电线全部暴露在外面，并且严重老化、受损，有的甚至将要断裂。“这可不行！”许老师心里想着，默默记下了这件事。",
          content3:
            "回到学校，许老师立即和同事们商量，想帮助老人解决这个问题。于是大家筹集资金，请供电所人员对程一枝家中的线路进行整理维修，并换上了新灯泡。经过一番整理，原本杂乱破旧的电线变得整齐干净，更重要的是老人的用电安全得到了保障。",
          content4:
            "看着整修完好的线路，明亮起来的房屋，许老师露出了欣慰的笑容。程一枝心里也甚是感激，被照亮的不仅是房子，更是老人的心窝。",
        },
        {
          id: "2",
          name: "绩溪县开展“祝福百岁老人”走访慰问活动",
          // photo1:require("./assets/big/wei1.png"),
          // photo2:require("./assets/big/wei2.png"),
          content1:
            "为弘扬中华民族孝老爱亲传统美德，进一步发扬尊老敬老的良好社会风尚，在全国第八个“老年节”（重阳节）来临之际,绩溪县老龄委开展“祝福百岁老人”上门走访慰问活动。",
          content2:
            " 10月20日-22日，县老龄委一行到瀛洲镇、华阳镇、伏岭镇、家朋乡等乡镇，上门走访慰问了汪荷花、程月时、胡永耀、汪华娟等7位百岁老人，深入了解他们的生活和健康状况，与老人及家人们亲切交谈，嘱咐老人的子女用自己的孝心赡养好老人，并为每位老人送上1000元慰问金和慰问信。",
          content3:
            "据悉，目前绩溪县60岁以上老年人口4.46万人，占全县总人口的25.41%；80岁以上高龄老年人6168人，占全县老年人口的13.83%，百岁老人7人。近年来，绩溪县委、政府高度重视老龄工作，多措并举抓牢抓实老年人补贴工作，不断健全养老保障服务体系，逐步形成保障高龄老人基本生活长效机制，有力保障广大高龄老人的基本生活，老年人的幸福指数进一步得到提高。（邵红慧）",
        },
        {
          id: "3",
          name: "九九艳阳天 浓浓敬老情——安徽省徽州学校学生志愿者赴金沙镇敬老院慰问孤寡老人",
          photo1: require("./assets/big/wei3.jpg"),
          content1:
            "为弘扬中华民族孝老爱亲传统美德，进一步发扬尊老敬老的良好社会风尚，在全国第八个“老年节”（重阳节）来临之际,绩溪县老龄委开展“祝福百岁老人”上门走访慰问活动。",
          content2:
            " 10月20日-22日，县老龄委一行到瀛洲镇、华阳镇、伏岭镇、家朋乡等乡镇，上门走访慰问了汪荷花、程月时、胡永耀、汪华娟等7位百岁老人，深入了解他们的生活和健康状况，与老人及家人们亲切交谈，嘱咐老人的子女用自己的孝心赡养好老人，并为每位老人送上1000元慰问金和慰问信。",
          content3:
            "据悉，目前绩溪县60岁以上老年人口4.46万人，占全县总人口的25.41%；80岁以上高龄老年人6168人，占全县老年人口的13.83%，百岁老人7人。近年来，绩溪县委、政府高度重视老龄工作，多措并举抓牢抓实老年人补贴工作，不断健全养老保障服务体系，逐步形成保障高龄老人基本生活长效机制，有力保障广大高龄老人的基本生活，老年人的幸福指数进一步得到提高。（邵红慧）",
        },
        {
          id: "4",
          name: "计生政策帮渡难关 贫困老人安享晚年",
          photo1: require("./assets/big/wei4.png"),
          content1:
            "“多亏了乡卫计办为我申请的这笔特殊家庭帮扶资金，家里的情况好很多啦。”近日，绩溪县家朋乡尚村计生专干在上户走访慰问计生特殊家庭户周春月时，她满是感激的对工作人员这么说。",
          content2:
            "周春月是家朋尚村建档立卡贫困户，患有大病，生活困难，前两年，唯一的儿子不幸落水去世，突如其来的噩耗让一下子压垮了老两口。没有了唯一的家庭支柱，老两口又年事已高，这个本就不富裕的家庭更是雪上加霜。灾祸无情人有情，听闻了周春月家情况后，计生干部立即上户安抚老两口情绪，了解生活困难。2020年，周春月老两口到了计生特殊特扶年龄要求，计生专干第一时间上户告知并帮助办理申请手续。今年7月，周春月首次拿到了这笔帮扶资金，今后老两口每年能享受计生帮扶资金1.2万元，这给失去家中独子的家庭带来了极大的安慰，为老两口的晚年生活提供了保障。",
          content3:
            "一直以来，家朋乡卫计办积极参与脱贫攻坚工作，为符合计生政策的贫困户提供帮扶，给他们更多的关心关怀、鼓励他们勤劳致富，让他们感受到“计生人”的温暖，增强贫困群众脱贫致富奔小康的信心于决心。（郑雪婷）",
        },
        {
          id: "5",
          name: "绩溪县民政局：全力做好养老机构疫情防控工作 保障老人生命健康安全",
          photo1: require("./assets/big/wei5.jpg"),
          content:
            "为做好新型冠状病毒感染的肺炎疫情防控工作，切实保障老年人生命健康安全，县民政局高度重视，及时研究部署疫情防控工作，强化责任担当，积极采取有力措施筑牢疫情防控安全线。",
          content2:
            "一、加强宣传引导。各养老机构采取通俗易懂的方式加强对此次疫情严峻性和危害性的宣传，提高工作人员和院内老人防范疫情的意识和能力。耐心做好与老人家属的沟通，取得家属的支持和配合，以便共同做好防范工作。",
          content3:
            "二、实行封闭管理。全县所有养老机构一律实行封闭式管理，严禁院民和老人外出活动，院外无关人员不得入内，同时在此期间谢绝亲朋好友探视探望。各养老机构采购物资和对外联络工作，一律在院外完成交接对接，非本单位办事人员不得在院内聚集停留，所采购的所有食品要一律索票索证。各乡镇养老服务指导中心和村级养老服务中心一律封闭停止活动，防止聚集性传染事件发生。",
          content4:
            "三、细化院内防护。要求养老机构工作人员强化自身防护，自觉佩戴口罩，餐具要实行高温消毒，室内外定期进行卫生消毒消杀工作。工作人员上班前及院民每天均要测量体温，凡发现有发热和感冒症状的，立即送定点医院机构就医检查。",
          content5:
            "四、严格返院检查。春节前由亲属接出养老机构的，原则上在防范疫情期间不得返院。确需返院入住的，要联系卫健部门对其实行冠状病毒排查，并对其在院外期间是否直接或间接接触过湖北省尤其是武汉市相关人员的情况进行排查，在确保未携带冠状病毒的前提下方可返院。在防范疫情期间，各养老机构不得接收新入住对象。（绩溪县民政局）",
        },
        {
          id: "6",
          name: "我县有序推进高龄老人津贴补贴发放工作",
          content:
            "为全面落实《安徽省老年人权益保障条例》和《宣城市高龄老人津贴发放实施办法》，大力弘扬中华民族养老、爱老、尊老传统，体现党和政府的关心和照顾，不断提升高龄老人生活幸福感，我县民政、财政等部门通力合作，精准推进，全面做好高龄津贴发放民生工程工作，取得了良好效果。",
          content2:
            "一是精心部署，明确工作责任。县民政局印发《关于做好2019年度高龄津贴老年人津贴发放工作的通知》，优化健全老年人补贴发放制度，精心部署，狠抓落实，部署2019年高龄津贴发放管理各项工作，切实保障老年人权益，广泛接受社会监督。",
          content3:
            "二是点面结合,强化政策宣传。充分利用信息网络、政务宣传栏等形式广泛宣传高龄津贴补助发放对象、申请手续、发放标准及程序等内容，同时不定期做好上门入户宣传讲解工作，让群众知标准、明手续、晓流程，将政策带到群众身边，为高龄津贴制度的实施营造良好氛围。",
          content4:
            "三是完善程序，实行有序更新。按照个人申请、乡镇审核、县民政局审批的程序办理，同时结合人口变动网络数据系统实施动态化管理，对新申请符合条件的高龄老人按期办理审批、新增手续，对死亡人员及时办理停发手续，及时更新信息台账，做到数据真实、准确、完整。",
          content5:
            "四是加强保障，严格项目监管。县财政年初将补贴资金纳入项目预算，专款专用。按照公平、公正原则建立补贴资金检查监督制度，适时组织开展上门问卷调查或专项检查,及时发现存在的问题，确保资金不错发、不漏发，严防挪用、克扣、截留事件发生，增强工作透明度。",
          content6:
            "截至12月底，全县享受高龄津贴老人6265人，发放高龄津贴补贴311.2万元，全部发放到高龄老人个人银行账户中。（胡伟）",
        },
      ],
      oldJoin: [],
      showJiJinInfo2: false,
      showJiJinInfo1: false,
      map: null,
      marker: null,
      markers: [],
      recMarker: [],
      personList: [
        {
          personAge: "33",
          personSex: "2",
          personName: "张站",
          personPhone: "15222241123",
          address: "绩溪县水岩村",
          longitude: "118.641356",
          latitude: "30.114539",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "张丹",
          personPhone: "15226241123",
          address: "绩溪县水岩村",
          longitude: "118.617928",
          latitude: "30.121911",
        },
        {
          personAge: "40",
          personSex: "1",
          personName: "方明",
          personPhone: "15246241123",
          address: "绩溪县水岩村",
          longitude: "118.617928",
          latitude: "30.121911",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "李青",
          personPhone: "13462415613",
          address: "绩溪县蒙山顶",
          longitude: "118.756482",
          latitude: "30.209901",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "王复天",
          personPhone: "13462415613",
          address: "绩溪县蒙山顶",
          longitude: "118.876482",
          latitude: "30.219901",
        },
        {
          personAge: "37",
          personSex: "1",
          personName: "林易",
          personPhone: "13475241613",
          address: "绩溪县土地堂",
          longitude: "118.850194",
          latitude: "30.26781",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "吴飞",
          personPhone: "13475641613",
          address: "绩溪县土地顶",
          longitude: "118.840194",
          latitude: "30.16781",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "吴杨",
          personPhone: "13475612613",
          address: "绩溪县土地顶",
          longitude: "118.640194",
          latitude: "30.15781",
        },
        {
          personName: "2222",
          personAge: "111",
          personSex: "2",
          personPhone: "18945678901",
          address: "绩溪县华阳镇龙川大道柏枝湾",
          longitude: "118.694024",
          latitude: "30.066273",
        },
        {
          personAge: "108",
          personSex: "2",
          personName: "服务人员同步3号",
          personPhone: "13900000001",
          address: "绩溪县华阳镇龙川大道柏枝湾",
          longitude: "118.694024",
          latitude: "30.266273",
        },
        {
          personAge: "21",
          personSex: "1",
          personName: "服务人员同步1号12",
          personPhone: "18822222341",
          address: "绩溪县华阳镇龙川大道柏枝湾",
          longitude: "118.614364",
          latitude: "30.057857",
        },
        {
          personAge: "42",
          personSex: "2",
          personName: "全功能服务1",
          personPhone: "18809090900",
          address: "绩溪县华阳镇龙川大道柏枝湾",
          longitude: "118.611274",
          latitude: "30.074497",
        },
        {
          personAge: "44",
          personSex: "2",
          personName: "服务",
          personPhone: "13934563456",
          address: "绩溪县临溪镇临溪村",
          longitude: "118.578776",
          latitude: "30.067538",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "11w",
          personPhone: "13244441212",

          address: "绩溪县临溪镇临溪村",
          longitude: "118.582693",
          latitude: "30.067069",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "笑笑",
          personPhone: "13245678909",
          address: "绩溪县临溪镇临溪村",
          longitude: "118.572994",
          latitude: "30.067812",
        },
        {
          personAge: "33",
          personSex: "2",
          personName: "小雪",
          personPhone: "13911112222",
          address: "绩溪县临溪镇临溪村",
          longitude: "118.574753",
          latitude: "30.068926",
        },
        {
          personAge: "120",
          personSex: "2",
          personName: "新增4",
          personPhone: "13111111111",
          address: "绩溪县长安镇镇头村",
          longitude: "118.628335",
          latitude: "30.154409",
        },
        {
          personAge: "120",
          personSex: "2",
          personName: "好家伙",
          personPhone: "13545566666",
          address: "绩溪县长安镇镇头村",
          longitude: "118.628335",
          latitude: "30.254409",
        },
        {
          personAge: "28",
          personSex: "2",
          personName: "耳热",
          personPhone: "13111111111",
          address: "绩溪县长安镇镇头村",
          longitude: "118.592391",
          latitude: "30.052211",
        },
        {
          personAge: "20",
          personSex: "1",
          personName: "二维",
          personPhone: "13111111111",
          address: "绩溪县长安镇镇头村",
          longitude: "118.614021",
          latitude: "30.07212",
        },
        {
          personAge: "28",
          personSex: "1",
          personName: "客服服务人员1",
          personPhone: "18822222222",
          address: "绩溪县上庄镇上庄村",
          longitude: "118.580547",
          latitude: "30.060383",
        },
        {
          personAge: "28",
          personSex: "2",
          personName: "客服服务人员",
          personPhone: "18822222222",
          address: "绩溪县上庄镇上庄村",
          longitude: "118.579173",
          latitude: "30.057857",
        },
        {
          personAge: "31",
          personSex: "2",
          personName: "nmnmnm",
          personPhone: "15222211123",
          address: "绩溪县上庄镇上庄村",
          longitude: "118.609901",
          latitude: "30.084598",
        },
        {
          personAge: "31",
          personSex: "1",
          personName: "ggggg",
          personPhone: "15055555555",
          address: "绩溪县上庄镇上庄村",
          longitude: "118.573165",
          latitude: "30.054589",
        },
        {
          personAge: "31",
          personSex: "2",
          personName: "ggggg",
          personPhone: "15055555555",
          address: "绩溪县扬溪镇大石门村",
          longitude: "118.588615",
          latitude: "30.053103",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "社区服务人员123",
          personPhone: "18855056500",

          address: "绩溪县扬溪镇大石门村",
          longitude: "118.803705",
          latitude: "30.261707",
        },
        {
          personAge: "34",
          personSex: "1",
          personName: "测试魏秀英",
          personPhone: "19823989384",

          address: "绩溪县扬溪镇大石门村",
          longitude: "118.612647",
          latitude: "30.088459",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "测试卢丽",
          personPhone: "19823989384",

          address: "绩溪县扬溪镇大石门村",
          longitude: "118.617797",
          latitude: "30.054589",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "测试丽",
          personPhone: "19823989384",

          address: "绩溪县板桥头乡尚田村",
          longitude: "118.614364",
          latitude: "30.083409",
        },
        {
          personAge: "36",
          personSex: "2",
          personName: "测试1丽",
          personPhone: "19823989384",

          address: "绩溪县板桥头乡尚田村",
          longitude: "118.545013",
          latitude: "30.066772",
        },
        {
          personAge: "36",
          personSex: "2",
          personName: "测试崔超",
          personPhone: "19823989384",

          address: "绩溪县板桥头乡尚田村",
          longitude: "118.639427",
          latitude: "30.064097",
        },
        {
          personAge: "36",
          personSex: "1",
          personName: "测试超",
          personPhone: "19823989384",

          address: "绩溪县金沙镇金沙村",
          longitude: "118.746959",
          latitude: "30.269039",
        },
        {
          personAge: "36",
          personSex: "1",
          personName: "测试汪艳",
          personPhone: "19823989384",

          address: "绩溪县金沙镇金沙村",
          longitude: "118.569045",
          latitude: "30.092618",
        },
        {
          personAge: "32",
          personSex: "1",
          personName: "测试杨丽",
          personPhone: "19823989384",

          address: "绩溪县金沙镇金沙村",
          longitude: "118.618484",
          latitude: "30.062315",
        },
        {
          personAge: "32",
          personSex: "1",
          personName: "测试萧霞",
          personPhone: "19823989384",

          address: "绩溪县金沙镇金沙村",
          longitude: "118.579002",
          latitude: "30.05132",
        },
        {
          personAge: "35",
          personSex: "1",
          personName: "马都",
          personPhone: "15475612513",
          address: "绩溪县栈路头顶",
          longitude: "118.556342",
          latitude: "30.089054",
        },

        {
          personAge: "33",
          personSex: "1",
          personName: "风高",
          personPhone: "15475612513",
          address: "绩溪县栈路头顶",
          longitude: "118.594795",
          latitude: "30.064395",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "高额",
          personPhone: "15475662513",
          address: "绩溪县乌焦山",
          longitude: "118.719688",
          latitude: "30.275795",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "高投",
          personPhone: "15375612513",
          address: "绩溪县乌焦山",
          longitude: "118.697841",
          latitude: "30.266812",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "解军",
          personPhone: "15375612513",
          address: "绩溪县竹根尖",
          longitude: "118.455227",
          latitude: "30.152957",
        },
        {
          personAge: "33",
          personSex: "1",
          personName: "何康",
          personPhone: "17875612513",
          address: "绩溪县竹根尖",
          longitude: "118.451777",
          latitude: "30.168445",
        },
      ],
      pInfo: {
        personAge: "",
        personSex: "",
        personName: "",
        personPhone: "",

        address: "",
      },
      stationList: [
        {
          id: "0",
          stationName: "华阳镇东山社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇东山社区",
          concatNam: "唐韫",
          phone: "15345636282",
          longitude: "118.608415",
          latitude: "30.07887",
        },
        {
          id: "1",
          stationName: "华阳镇杨柳社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇杨柳社区",
          concatNam: "周正益",
          phone: "13966203888",
          longitude: "118.596285",
          latitude: "30.066105",
        },
        {
          id: "2",
          stationName: "华阳镇霞涧社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇霞涧社区",
          concatNam: "汪沛",
          phone: "18098565555",
          longitude: "118.579815",
          latitude: "30.072999",
        },
        {
          id: "3",
          stationName: "华阳镇凤灵社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇凤灵社区",
          concatNam: "许令星",
          phone: "13966203039",
          longitude: "118.590762",
          latitude: "30.059501",
        },
        {
          id: "4",
          stationName: "华阳镇来苏社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇来苏社区",
          concatNam: "邵鹏",
          phone: "13655637311",
          longitude: "118.592986",
          latitude: "30.071278",
        },
        {
          id: "5",
          stationName: "华阳镇五龙社区养老机构",
          stationAddress: "安徽省宣城市绩溪县华阳镇五龙社区",
          concatNam: "吴继光",
          phone: "18098567909",
          longitude: "118.602642",
          latitude: "30.077145",
        },
      ],
      info: {
        stationName: "",
        stationAddress: "",
        concatNam: "",
        phone: "",
      },
    }
  },
  filters: {},
  computed: {
    defaultOption() {
      return {
        oldJoin: [],
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 9, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  mounted() {
    const self = this
    self.$nextTick(() => {
      self.loadMap().then(() => {
        self.getDistrict()
        self.getStation() //站点
        self.currentBulidingArea() //建筑面积
        self.currentBednums() //床位数
        self.getactivesList() //获取活动列表数据
        self.getSiteData()
        self.bathPoint()
        self.serverList()
      })
    })
  },
  methods: {
    showInfo(id) {
      this.showJiJinInfo3 = true
      this.activesList.forEach((item) => {
        if (id == item.id) {
          this.huodongForm = item
        }
      })
    },
    close() {
      this.showJiJinInfo3 = false
    },
    // 服务人员
    serverList() {
      // recMarker
      const self = this
      let f1 = require("./assets/big/adIcon4.png")
      this.personList.forEach((item, i) => {
        let icon = f1
        let marker = new AMap.Marker({
          position: [item.longitude, item.latitude],
          icon: new AMap.Icon({
            image: icon,
            size: new AMap.Size(52, 52), //图标大小
            imageSize: new AMap.Size(30, 30),
          }),
          extData: {
            personAge: item.personAge,
            personSex: item.personSex,
            personName: item.personName,
            personPhone: item.personPhone,
            address: item.address,
          },
        })
        self.recMarker.push(marker)

        marker.on("click", self.maskServe)
      })
      self.map.add(self.recMarker)
    },
    maskServe(e) {
      let data = e.target.w.extData
      this.pInfo = {
        personAge: data.personAge,
        personSex: data.personSex,
        personName: data.personName,
        personPhone: data.personPhone,
        address: data.address,
      }
      this.showJiJinInfo1 = true
    },
    // 批量打点
    bathPoint() {
      const self = this
      let f1 = require("./assets/big/adIcon1.png")
      this.stationList.forEach((item, i) => {
        let icon = f1
        let marker = new AMap.Marker({
          position: [item.longitude, item.latitude],
          icon: new AMap.Icon({
            image: icon,
            size: new AMap.Size(52, 52), //图标大小
            imageSize: new AMap.Size(30, 30),
          }),
          extData: {
            id: item.id,
            stationName: item.stationName,
            stationAddress: item.stationAddress,
            concatNam: item.concatNam,
            phone: item.phone,
          },
        })
        self.markers.push(marker)

        marker.on("click", self.maskModel)
      })
      self.map.add(self.markers)
    },
    maskModel(e) {
      let data = e.target.w.extData
      this.info = {
        stationName: data.stationName,
        stationAddress: data.stationAddress,
        concatNam: data.concatNam,
        phone: data.phone,
      }
      this.showJiJinInfo2 = true
      // console.log(e.target.w.extData, "点击事件")
    },
    // 老人参与
    olderJoins() {
      let xData = []

      if (this.oldJoin == [] || this.oldJoin == null) {
        xData = []
      } else {
        this.oldJoin.forEach((item) => {
          xData.push(item.participantsNumber)
        })
      }
      const myChart = this.$echarts.init(document.getElementById("olderJoin"))
      var option
      option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
          data: ["志愿", "养生", "健身", "法律", "其他"],
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
        },
        series: [
          {
            data: xData,
            type: "bar",
            smooth: true,
            // color: "#D800FF",
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList2 = [
                    "#D800FF",
                    "#7FD42D",
                    "#F21B62",
                    "#0F5BF5",
                    "#50b7c1",
                  ]
                  return colorList2[params.dataIndex]
                },
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    getSiteData() {
      const self = this
      let params = {
        pageNo: 1,
        pageSize: 10,
      }
      this.$http
        .request({
          url: "/ypt/admin/site/info/getSiteData",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            let data = res.content
            let activityTotal = data.dataByLabel //活动总数  标签
            this.alltotal = data.dataByLabel.total //总数
            if (activityTotal.label1 == 0) {
              this.label1 = 0
            } else {
              this.label1 = (activityTotal.label1 / this.alltotal) * 100
              this.label1 = Number(this.label1)
              if ((this.label1 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label1 = this.label1.toFixed(2)
              } else {
                this.label1 = this.label1
              }
            }
            if (activityTotal.label2 == 0) {
              this.label2 = 0
            } else {
              this.label2 = (activityTotal.label2 / this.alltotal) * 100
              this.label2 = Number(this.label2)
              if ((this.label2 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label2 = this.label2.toFixed(2)
              } else {
                this.label2 = this.label2
              }
            }
            if (activityTotal.label3 == 0) {
              this.label3 = 0
            } else {
              this.label3 = (activityTotal.label3 / this.alltotal) * 100
              this.label3 = Number(this.label3)
              if ((this.label2 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label3 = this.label3.toFixed(2)
              } else {
                this.label3 = this.label3
              }
            }
            if (activityTotal.label4 == 0) {
              this.label4 = 0
            } else {
              this.label4 = (activityTotal.label4 / this.alltotal) * 100
              this.label4 = Number(this.label4)
              if ((this.label4 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label4 = this.label4.toFixed(2)
              } else {
                this.label4 = this.label4
              }
            }
            if (activityTotal.label5 == 0) {
              this.label5 = 0
            } else {
              this.label5 = (activityTotal.label5 / this.alltotal) * 100
              if ((this.label5 + "").indexOf(".") != -1) {
                //判断是否有小数点
                this.label5 = this.label5.toFixed(2)
              } else {
                this.label5 = this.label5
              }
            }
            self.oldJoin = data.numberDataByLabel //老人参与
            self.olderJoins()
          }
        })
    },
    getactivesList() {
      // let params = {
      //   pageNo: -1,
      //   pageSize: 999,
      // }
      // this.$http
      //   .request({
      //     url: "/ypt/admin/activityList/info/findListVisualization",
      //     method: "POST",
      //     data: params,
      //   })
      //   .then((res) => {
      //     if (res.code == 200) {
      //       this.activesList = res.content.list
      //     }
      //   })
    },
    format(percentage) {
      return ""
    },
    //工作人数
    currentBednums() {
      let xData = [
          "华阳镇敬老院",
          "临溪镇敬老院",
          "长安镇敬老院",
          "上庄镇敬老院",
          "扬溪镇敬老院",
          "板桥头乡敬老院",
          "金沙镇敬老院",
          "伏岭镇敬老院",
          "家朋乡敬老院",
          "荆州乡敬老院",
          "龙川中心敬老院",
        ],
        yData = ["3", "4", "6", "5", "3", "5", "4", "6", "4", "3", "7"]
      const myChart = this.$echarts.init(document.getElementById("bedNums"))
      var option
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "15%",
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 65,
            textStyle: {
              color: "#BAC0EB",
              fontSize: "10",
            },
            formatter: function (params) {
              var tempStr = params.substring(0, 4)
              var tempStr1 = params.substring(4, params.length)
              var tempStr2 = tempStr + "\n" + tempStr1
              return tempStr2
            },
          },
          data: xData,
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#1540B6", //左边线的颜色
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            textStyle: {
              color: "#BAC0EB",
              fontSize: "12",
            },
          },
        },
        dataZoom: {
          show: true,
          realTime: true,
          height: 20,
          start: 20,
          end: 80,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            data: yData,
            type: "bar",
            barWidth: 12,
            color: "#0F5BF5",
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 16,
                  },
                },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 建筑面积
    currentBulidingArea() {
      let xData = [
          "华阳镇敬老院",
          "临溪镇敬老院",
          "长安镇敬老院",
          "上庄镇敬老院",
          "扬溪镇敬老院",
          "板桥头乡敬老院",
          "金沙镇敬老院",
          "伏岭镇敬老院",
          "家朋乡敬老院",
          "荆州乡敬老院",
          "龙川中心敬老院",
        ],
        yData = [
          "1100",
          "1200",
          "2500",
          "3400",
          "1050",
          "2050",
          "1700",
          "5860",
          "854",
          "350",
          "6670",
        ]
      const myChart = this.$echarts.init(
        document.getElementById("currentBulidingArea")
      )
      var option
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: [],
        },
        grid: {
          left: "14%",
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xData,
            axisLabel: {
              formatter: "{value}",
              // rotate: 65,
              textStyle: {
                fontSize: "10",
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                fontSize: "10",
                color: "#fff",
              },
            },
          },
        ],
        dataZoom: {
          show: true,
          realTime: true,
          height: 20,
          start: 20,
          end: 80,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "",
            type: "line",
            stack: "总量",
            smooth: true,
            center: ["30%", "40%"],
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: "#F21B62",
            },
            emphasis: {
              focus: "series",
            },
            data: yData,
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 站点等级占比
    getStation() {
      const myChart = this.$echarts.init(
        document.getElementById("currentSituation")
      )
      var option
      option = {
        legend: {
          icon: "circle",
          textStyle: { color: "#FFFDFE" },
          bottom: 0,
          selectedMode: true, //取消图例上的点击事件
          data: ["AAAAA", "AAAA", "AAA", "AA", "A"],
        },
        //点击提示文字
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        //环形颜色
        color: ["#D800FF", "#FFB026", "#0F5BF5", "#009ad6", "#45b97c"],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["35%", "50%"], //两个表示环：内半径,外半径
            center: ["50%", "50%"], //左右，上下
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: "outside",
                // formatter: '{d}%, {c} \n\n',
                //模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等。
                // formatter: "{d}%",
                borderWidth: 5,
                borderRadius: 4,
                //  padding: [90, -50],
                rich: {
                  a_set: {
                    color: "#FFF",
                    lineHeight: 20,
                    align: "center",
                  },
                  c_set: {
                    color: "#FFF",
                  },
                },
              },
            },
            //牵引线条颜色
            labelLine: {
              normal: {
                show: true,
                showAbove: true,
                length: 20,
                length2: 35,
                lineStyle: {
                  color: "orange",
                },
              },
            },
            data: [
              { value: "0", name: "A" },
              { value: "47.06", name: "AA" },
              { value: "52.49", name: "AAA" },
              { value: "0", name: "AAAA" },
              { value: "0", name: "AAAAA" },
            ],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} :({d}%)",
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          mapStyle: "amap://styles/darkblue",
          zoom: 10,
          center: ["118.87", "30.07"],
        })
        resolve()
      })
    },
    drawArea() {
      for (let i = 0; i < this.areaList.length; i++) {
        // console.log(this.areaList,'2222')
        this.getArea(this.areaList[i].adcode, this.areaList[i].color)
      }
    },
    getArea(name, color) {
      // console.log(name, color)
      const self = this
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let bounds = result.districtList[0].boundaries
          self.polygons = []
          for (var i = 0, l = bounds.length; i < l; i++) {
            self.polygon = new AMap.Polygon({
              map: self.map,
              strokeWeight: 1,
              strokeColor: "#007CDB",
              fillColor: color,
              fillOpacity: 0.06,
              path: bounds[i],
            })
            self.polygons.push(self.polygon)
          }
          // self.map.setFitView() //地图自适应
        }
      })
    },
    getDistrict(name = "341824", params = null) {
      let self = this
      // return new Promise((resolve, reject) => {
      var opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }
      let district = new AMap.DistrictSearch(opts)

      try {
        self.map.remove(self.marker)
      } catch (err) {
        console.log(err)
      }

      self.marker = new AMap.Marker()
      district.search(name, (status, result) => {
        if (status == "complete") {
          let areaList = []
          result.districtList[0].districtList.forEach((item) => {
            // console.log(item, "下次code")
            areaList.push({
              adcode: item.adcode,
              name: item.name,
            })
          })
          areaList[0].color = "#24609C"
          areaList[1].color = "#467399"
          areaList[2].color = "#0C2FA0"
          areaList[3].color = "#3769A6"
          areaList[4].color = "#22598D"
          areaList[5].color = "#326A9D"
          areaList[6].color = "#0C2FA0"
          areaList[7].color = "#2568A2"
          areaList[8].color = "#134CA2"
          areaList[9].color = "#183B77"
          areaList[10].color = "#183B70"
          areaList[11].color = "#183B70"

          self.areaList = areaList
          self.drawArea()
        }
      })
    },
  },
  activated() {
    let self = this
  },
  beforeDestory() {},
}
</script>

<style lang="less" scoped>
.main {
  overflow-x: hidden;
  width: 100%;
  .mymap {
    width: 100%;
    height: 100vh;
  }
  #olderJoin {
    width: 100%;
    height: 30vh;
  }
  .oldBox {
    border: 1px solid rgba(34, 236, 255, 1);
    background: #01117b;
    margin-top: 28px;
    position: relative;
    min-height: 35px;
    .leftTitle {
      position: absolute;
      width: 100%;
      height: 35px;
      background: url("./assets/big/titleLeft.png") no-repeat center;
      text-align: center;
      font-size: 17px;
      line-height: 35px;
      color: #22f7ff;
      top: -17px;
    }
    .housexz {
      position: relative;
      top: 10px;
      background-size: 100%;
      padding: 0 10px;
      width: 50%;
      height: 50%;
      text-align: center;
    }
    .workInfo {
      position: relative;
      top: 10px;
      background-size: 100%;
      width: 105px;
      height: 105px;
      text-align: center;
    }
  }
  .realLeft {
    position: absolute;
    top: 100px;
    left: 20px;
    width: 400px;
    height: 300px;
    z-index: 100;
    #totalHouse {
      width: 100%;
      height: 28vh;
    }
    #currentSituation,
    #currentBulidingArea,
    #bedNums {
      width: 100%;
      height: 26vh;
    }
    .leftTitle {
      background-size: 100%;
      width: 80%;
      left: 25px;
    }
  }
  .realRight {
    position: absolute;
    top: 100px;
    right: 20px;
    width: 700px;
    height: 300px;
    z-index: 100;
  }
}
.smallt {
  color: #6ebcff;
}
.newSty {
  display: flex;
  justify-content: space-between;
  margin: 15px 10% 0;
  width: 80%;
  span {
    display: inline-block;
    font-size: 12px;
    color: #fff;
  }
  /deep/.el-progress {
    flex: 1;
    width: 60%;
    margin: 0 8px;
  }
}

.activeList {
  color: #fff;
  flex: 1;
  margin-left: 20px;
  text-align: center;
  font-size: 14px;
  height: 30vh;
  overflow: scroll;
}
.houseContent {
  overflow: hidden;
  margin-top: 10px;
  height: 63vh;
  .houseItem {
    line-height: 25px;
    font-size: 13px;
    color: #e4e4e4;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    margin-top: 25px;
  }
  .flexs {
    display: flex;
    p {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.ac-title {
  color: #1a46f7;
  font-size: 16px;
  padding: 5px 10px 15px 10px;
  border-bottom: 2px solid #0f5bf5;
  position: relative;
  z-index: 99;
  background: #01117b;
}
.ac-item {
  padding: 15px 10px;
  border-bottom: 1px solid #0f5bf5;
  font-size: 13px;
  cursor: pointer;
}
.perInfoBox2 {
  background: rgba(7, 17, 27, 0.5);
  position: fixed;
  width: 100%;
  top: 0%;
  bottom: 0;
  z-index: 999;
}
.close-info2 {
  color: #22f7ff;
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 30px;
  cursor: pointer;
}
.info-txt2 {
  position: relative;
  color: #fff;
  width: 60%;
  font-size: 14px;
  overflow: scroll;
  margin: 10px auto;
  background: rgba(10, 88, 160, 1);
}
.info-item2 {
  border-bottom: 1px solid #085e98;
  padding: 20px 30px;
  line-height: 40px;
  height: 633px;
  // height: 300PX;
}
.intitle2 {
  color: #22f7ff;
  font-size: 18px;
  padding-left: 10px;
}
.defaultImg {
  width: 160px;
  height: 160px;
}
.close-info {
  color: #ffffff;
  position: absolute;
  top: 0px;
  right: 20px;
  font-size: 30px;
  cursor: pointer;
  z-index: 1001000;
}
.info-txt3 {
  position: relative;
  color: #fff;
  width: 50%;
  font-size: 14px;
  // overflow: scroll;
  margin: 10px auto;
  background: rgba(10, 88, 160, 0.8);
}
.intitle {
  color: #ffffff;
  font-size: 20px;
  font-weight: 200;
  margin-bottom: 20px;
  height: 30px;
  line-height: 30px;
}
</style>
